// extracted by mini-css-extract-plugin
module.exports = {"spark":"Sparkline_spark__brXFR","area":"Sparkline_area__ZZVWS","line":"Sparkline_line__P_d3W","dot":"Sparkline_dot__S8Clc"};